import { useEffect, useState } from 'react';
import { settlementsApi, AwaitingTabbySettlement } from '../../services/settlementsApi';
import { useAuth } from '../../hooks/useAuth';

interface AwaitingTabbyCardProps {
  garageId: string;
}

const aed = (n: number) => `AED ${n.toLocaleString('en-AE', { minimumFractionDigits: 2 })}`;

/**
 * Spec 067 (DD4) — Tabby-paid orders still inside the Tabby holding period. Informational only:
 * these orders are not in the next payout and must never be added to any payable total.
 */
export default function AwaitingTabbyCard({ garageId }: AwaitingTabbyCardProps) {
  const auth = useAuth();
  const [awaiting, setAwaiting] = useState<AwaitingTabbySettlement | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!auth.token) return;
    let cancelled = false;
    settlementsApi.getGarageSettlementSummary(garageId, auth.token)
      .then((res) => { if (!cancelled) setAwaiting(res.awaitingTabbySettlement); })
      .catch((err) => { if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load'); });
    return () => { cancelled = true; };
  }, [auth.token, garageId]);

  let body: string;
  if (error) body = error;
  else if (!awaiting) body = 'Loading...';
  else if (awaiting.count === 0) body = 'None';
  else {
    const orders = `${awaiting.count} ${awaiting.count === 1 ? 'order' : 'orders'}`;
    const released = awaiting.earliestEligibleAt
      ? `, released from ${new Date(awaiting.earliestEligibleAt).toLocaleDateString()}`
      : '';
    body = `${orders}, ${aed(awaiting.grossAmount)}${released}`;
  }

  return (
    <div className="admin-card" style={{ marginTop: '1rem' }} data-testid="awaiting-tabby-card">
      <h3 className="admin-card-title" style={{ marginBottom: '0.5rem' }}>Awaiting Tabby settlement</h3>
      <p style={{ margin: 0, fontSize: '0.875rem', color: error ? '#dc2626' : 'var(--admin-text)' }}>{body}</p>
      <p style={{ margin: '0.25rem 0 0', fontSize: '0.75rem', color: 'var(--admin-text-muted)' }}>
        Tabby orders still in the Tabby holding period. Not part of the next payout.
      </p>
    </div>
  );
}
